import React, { useEffect, useMemo, useState } from "react";
import api from "../../services/api";

const formatPercent = (value) => {
  const numeric = Number(value || 0);
  if (Number.isNaN(numeric)) return 0;
  return Math.max(0, Math.min(100, numeric));
};

export default function HorasPorExecutante() {
  const [projetos, setProjetos] = useState([]);
  const [projetoSelecionado, setProjetoSelecionado] = useState("");
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingProjetos, setLoadingProjetos] = useState(false);

  useEffect(() => {
    const carregarProjetos = async () => {
      setLoadingProjetos(true);
      try {
        const response = await api.get("/api/planejamentoProjetos");
        setProjetos(response.data || []);
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
      } finally {
        setLoadingProjetos(false);
      }
    };

    carregarProjetos();
  }, []);

  const projetoId = useMemo(() => {
    if (!projetoSelecionado) return "";
    const projeto = projetos.find((item) => item.nome === projetoSelecionado);
    return projeto ? projeto.id : "";
  }, [projetoSelecionado, projetos]);

  useEffect(() => {
    const buscarHorasPorExecutante = async () => {
      setLoading(true);
      try {
        const requestConfig = projetoSelecionado
          ? { params: { idProjeto: projetoId } }
          : {};

        const response = await api.get("/hoursPerUser", requestConfig);
        setDados(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Erro ao buscar horas por executante:", error);
        setDados([]);
      } finally {
        setLoading(false);
      }
    };

    buscarHorasPorExecutante();
  }, [projetoSelecionado, projetoId]);

  return (
    <div style={{ background: "#f3f4f6", minHeight: "100vh", padding: "32px 0 60px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        <div
          style={{
            fontSize: "12px",
            color: "#6b7280",
            marginBottom: "18px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>Home</span>
          <span>›</span>
          <span>Gestão</span>
          <span>›</span>
          <strong style={{ color: "#374151" }}>Horas por executante</strong>
        </div>

        <h1 style={{ fontSize: "44px", margin: 0, fontWeight: 700, color: "#1f2937" }}>
          Horas por executante
        </h1>
        <p style={{ margin: "8px 0 20px", color: "#4b5563", fontSize: "18px" }}>
          Horas previstas e realizadas por cada executante
        </p>

        <div
            style={{
                borderTop: "1px dashed #d1d5db",
                marginBottom: "24px",
                paddingTop: "18px"
            }}
        >
          <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                flexWrap: "wrap"
            }}
          >
            <div style={{ flex: 1, minWidth: 240 }}>
              <label
                style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: 600,
                    color: "#374151"
                }}
              >
                Selecione projeto
              </label>

              <select
                value={projetoSelecionado}
                onChange={(event) => setProjetoSelecionado(event.target.value)}
                disabled={loadingProjetos}
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  height: "42px",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  background: "#fff",
                  fontSize: "16px",
                  color: "#111827",
                }}
              >
                <option value="">{loadingProjetos ? "Carregando..." : "Todos os projetos"}</option>
                {projetos.map((projeto) => (
                  <option key={projeto.id} value={projeto.nome}>
                    {projeto.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {!projetoSelecionado && (
            <div style={{ marginTop: "10px", color: "#6b7280", fontSize: "14px" }}>
                Selecione o projeto para ter acesso aos detalhes de cada executante.
            </div>
          )}
        </div>

        <div
            style={{
                background: "#f8fafc",
                border: "1px solid #dfe3e8",
                borderRadius: "10px",
                overflow: "hidden"
            }}
        >
          <div
            style={{
                padding: "12px 14px",
                color: "#374151",
                fontWeight: 700,
                fontSize: "18px"
            }}
          >
            Horas por executante
          </div>

          {loading ? (
            <div style={{ padding: "18px 14px", color: "#6b7280" }}>Carregando...</div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ background: "#f3f4f6" }}>
                  <tr>
                    <th
                        style={{
                            textAlign: "left",
                            padding: "12px 14px",
                            color: "#374151",
                            borderBottom: "1px solid #dfe3e8"
                        }}
                    >
                      Executante
                    </th>
                    <th
                        style={{
                            textAlign: "left",
                            padding: "12px 14px",
                            color: "#374151",
                            borderBottom: "1px solid #dfe3e8"
                        }}
                    >
                      Previstas
                    </th>
                    <th
                        style={{
                            textAlign: "left",
                            padding: "12px 14px",
                            color: "#374151",
                            borderBottom: "1px solid #dfe3e8"
                        }}
                    >
                      Realizadas
                    </th>
                    <th
                        style={{
                            textAlign: "right",
                            padding: "12px 14px",
                            color: "#374151",
                            borderBottom: "1px solid #dfe3e8"
                        }}
                    >
                      % Executada
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {dados.length === 0 && (
                    <tr>
                      <td
                        colSpan={4}
                        style={{
                            textAlign: "center",
                            color: "#6b7280",
                            padding: "18px"
                        }}
                      >
                        Nenhum dado encontrado.
                      </td>
                    </tr>
                  )}

                  {dados.map((item, index) => {
                    const percentual = formatPercent(item.percentualExecutado);
                    return (
                      <tr
                        key={`${item.executante}-${index}`}
                        style={{
                            background: index % 2 === 0 ? "#ffffff" : "#f9fafb"
                        }}
                      >
                        <td
                            style={{
                                padding: "12px 14px",
                                borderBottom: "1px solid #e5e7eb",
                                color: "#111827"
                            }}
                        >
                          {item.executante}
                        </td>
                        <td
                            style={{
                                padding: "12px 14px",
                                borderBottom: "1px solid #e5e7eb",
                                color: "#111827"
                            }}
                        >
                          {item.previstas}
                        </td>
                        <td
                            style={{
                                padding: "12px 14px",
                                borderBottom: "1px solid #e5e7eb",
                                color: "#111827"
                            }}
                        >
                          {item.realizadas}
                        </td>
                        <td
                            style={{
                                padding: "12px 14px",
                                borderBottom: "1px solid #e5e7eb",
                                textAlign: "right"
                            }}
                        >
                          <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                gap: "10px"
                            }}
                          >
                            <span
                                style={{
                                    color: "#111827",
                                    fontWeight: 600
                                }}
                            >
                                {percentual}%
                            </span>
                            <div
                              style={{
                                position: "relative",
                                width: "120px",
                                height: "18px",
                                borderRadius: "999px",
                                overflow: "hidden",
                                background: "#dfe3e8",
                                border: "1px solid #cbd5e1",
                              }}
                            >
                              <div
                                style={{
                                  width: `${percentual}%`,
                                  height: "100%",
                                  background: "#111827",
                                  borderRadius: "999px",
                                }}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
